<template>
    <div class="lock-screen-container">
        <div class="lock-screen-wrapper" style="height: 100vh;">
            <div class="dis-table">
                <div class="table-cell">
                    <main class="main-content">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-5 col-md-6 col-sm-12">
                                    <form @keydown="form.errors.clear($event.target.name)" @submit.prevent="submitForm"
                                          class="login p-4">
                                        <div class="form-group text-center">
                                            <b>Сессия устарела. Введите пароль для продолжения работы.</b>
                                        </div>
                                        <div class="form-group">
                                            <label class="mb-0 mr-4">Логин: </label> <i>{{ form.email }}</i>
                                            (<a @click.prevent="logout(unlock)" href="#"><u class="text-primary">Выход</u></a>)<br/>
                                            <input type="hidden" v-model="form.email">
                                            <div class="d-flex align-items-center mt-3">
                                                <label class="mb-0 mr-3">Пароль:</label>
                                                <password-input wrapper-class="input-group-sm" :class-name="form.errors.has('password') || form.errors.errorMessage ? 'is-invalid' : ''" :on-enter="submitForm" v-model="form.password">
                                                    <div class="invalid-feedback" v-if="form.errors.has('password') || form.errors.errorMessage">
                                                        {{form.errors.get('password')}} {{form.errors.errorMessage}}
                                                    </div>
                                                </password-input>
                                            </div>
                                        </div>
                                        <button class="btn w-100 base_btn solid_blue waves-effect waves-light" type="submit">
                                            <span class="loader-15" v-if="isLoading"></span>
                                            <span v-else>Вход</span>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormService from "../services/FormService";
    import PasswordInput from "./PasswordInput";

    export default {
        name: 'lock-screen',
        components: {PasswordInput},
        data() {
            return {
                form: new FormService({
                    email: '',
                    password: ''
                }),
                isLoading: false,
                isShowedPassword: false,
            }
        },
        mounted() {
            this.form.email = this.authData.user.email;
        },
        computed: {
            authData() {
                let ls = localStorage.getItem('auth');
                if (ls) {
                    return JSON.parse(ls);
                }
                return {user: {email: ''}};
            }
        },
        methods: {
            unlock() {
                this.$store.commit('unlockScreen');
            },
            showPassword() {
                this.isShowedPassword = !this.isShowedPassword;
            },
            submitForm() {
                this.isLoading = true;
                this.form.submit('POST', this.route('api.login'))
                    .then(({errors, data}) => {
                        if (!errors) {
                            if (data.access_token) {
                                let authObj = JSON.stringify(data.auth);
                                localStorage.setItem('authToken', data.access_token);
                                localStorage.setItem('auth', authObj);
                                this.$store.commit('loadAuth', authObj);
                                this.$store.commit('loadPerms', data.auth.permissions);
                                this.unlock();
                            }
                        } else {
                            alert('error, open console');
                            console.log(errors);
                        }
                    })
                    .catch(error => {
                        this.form.errors.errorMessage = "Wrong credentials";
                    }).finally(() => {
                    this.isLoading = false;
                });
            }
        }
    }
</script>

<style scoped>
    .lock-screen-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(204, 204, 204, 0.6);
        z-index: 1000;
    }

    .lock-screen-wrapper {
        height: 100%;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
</style>
